import React from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
// import BgVirtualExplorer from "Utils/Assets/Images/BgVirtualExplorer.png";
import cardExplorerImage1 from "Utils/Assets/Images/cardExplorerImage1.png";
import cardExplorerImage2 from "Utils/Assets/Images/cardExplorerImage2.png";
import cardExplorerImage3 from "Utils/Assets/Images/cardExplorerImage3.png";
import ArrowLeft from "Utils/Assets/Icons/ArrowLeft";
import ArrowRight from "Utils/Assets/Icons/ArrowRight";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const VirtualExplorer = () => {
    return (
        <div>
            <div className={styles.virtualWrapper}>
                {/* <img
                    src={BgVirtualExplorer}
                    alt="meetBg"
                    className={styles.virtualBg}
                /> */}
                <MeetUsWrapper>
                    <div className={styles.virtualContent}>
                        <div className="">
                            <h1 className={styles.virtualTitle}>
                                Explore Our Immersive <br /> Virtual Spaces
                            </h1>
                        </div>

                        <div className={styles.swiperWrapper}>
                            <Swiper
                                modules={[Navigation]}
                                navigation={{
                                    prevEl: `.${styles.arrowLeft}`,
                                    nextEl: `.${styles.arrowRight}`,
                                }}
                                slidesPerView={3}
                                spaceBetween={16}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 10,
                                    },
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 16,
                                    },
                                    1024: {
                                        slidesPerView: 3,
                                        spaceBetween: 30,
                                    },
                                }}
                                className={styles.mySwiper}
                            >
                                <SwiperSlide>
                                    <div
                                        className={styles.card}
                                        data-aos="fade-up"
                                        data-aos-duration="1000"
                                    >
                                        <img
                                            src={cardExplorerImage1}
                                            alt="Card Explorer 1"
                                            className={styles.cardImage}
                                        />

                                        <div className={styles.cardContent}>
                                            <h2 className={styles.cardTitle}>
                                                Infinity Arena
                                            </h2>
                                            <p
                                                className={
                                                    styles.cardDescription
                                                }
                                            >
                                                A futuristic space for esports &
                                                competitions.
                                            </p>
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div
                                        className={styles.card}
                                        data-aos="fade-up"
                                        data-aos-duration="1000"
                                    >
                                        <img
                                            src={cardExplorerImage2}
                                            alt="Card Explorer 2"
                                            className={styles.cardImage}
                                        />

                                        <div className={styles.cardContent}>
                                            <h2 className={styles.cardTitle}>
                                                Metaverse Plaza
                                            </h2>
                                            <p
                                                className={
                                                    styles.cardDescription
                                                }
                                            >
                                                A high-traffic area for public
                                                talks & networking.
                                            </p>
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div
                                        className={styles.card}
                                        data-aos="fade-up"
                                        data-aos-duration="1000"
                                    >
                                        <img
                                            src={cardExplorerImage3}
                                            alt="Card Explorer 3"
                                            className={styles.cardImage}
                                        />

                                        <div className={styles.cardContent}>
                                            <h2 className={styles.cardTitle}>
                                                Infinity Arena
                                            </h2>
                                            <p
                                                className={
                                                    styles.cardDescription
                                                }
                                            >
                                                A futuristic space for esports &
                                                competitions.
                                            </p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div
                                        className={styles.card}
                                        data-aos="fade-up"
                                        data-aos-duration="1000"
                                    >
                                        <img
                                            src={cardExplorerImage1}
                                            alt="Card Explorer 1"
                                            className={styles.cardImage}
                                        />

                                        <div className={styles.cardContent}>
                                            <h2 className={styles.cardTitle}>
                                                Infinity Arena
                                            </h2>
                                            <p
                                                className={
                                                    styles.cardDescription
                                                }
                                            >
                                                A futuristic space for esports &
                                                competitions.
                                            </p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>

                        <div className={styles.arrow}>
                            <div className={styles.arrowLeft}>
                                <ArrowLeft />
                            </div>
                            <div className={styles.arrowRight}>
                                <ArrowRight />
                            </div>
                        </div>
                    </div>
                </MeetUsWrapper>
            </div>
        </div>
    );
};

export default VirtualExplorer;
